module.exports = __webpack_public_path__ + "static/l2-service-img4-bdbd30d98158df116b2ac57d5394921b.jpg";